declare global {
  interface Window {
    REACT_APP_CONFIG: { [key: string]: string }
  }
}

export const getRuntimeConfig = (key: string, defaultValue: string = ''): string => {
  if (window.REACT_APP_CONFIG && window.REACT_APP_CONFIG[key]) {
    const value = window.REACT_APP_CONFIG[key]

    if (key === 'REACT_APP_API_URL' && value.endsWith('/')) {
      return value.slice(0, -1)
    }

    return value
  }

  if (process.env && process.env[key]) {
    const value = process.env[key] || defaultValue

    if (key === 'REACT_APP_API_URL' && value.endsWith('/')) {
      return value.slice(0, -1)
    }

    return value
  }

  console.warn(`${key} not found, using default value`)
  return defaultValue
}
